import { Typography, Box, Stack } from "@mui/material";
import Male from '../../../../assets/maleNurse.svg'
import Female from '../../../../assets/femaleNurse.svg'
import { withTheme } from "@emotion/react";
import { useState,useEffect } from "react";



const Banner = (props) => {

    const theme = props.theme

    const [isMobile, setIsMobile] = useState(false)
 
//choose the screen size 
const handleResize = () => {
  if (window.innerWidth < 720) {
      setIsMobile(true)
      
  } else {
      setIsMobile(false)
  }
 
}

// create an event listener
useEffect(() => {
  window.addEventListener("resize", handleResize)
},[])
    

    return (<Box borderRadius= '8px' mt="164px" mb="96px" position="relative" bgcolor={theme.palette.primary.main} height={{xs:'670px',lg:'255px'}}  alignItems="center" display="flex" flexDirection={{xs:"column", sm:'column',md:'column',lg:'row'}} sx={{ width: '100%' }}>
        <Stack alignItems={{ md:'center',lg:'start'}} padding="48px" >
            <Typography fontSize="32px" fontFamily="Inter" fontWeight={700} color="#FFF">Be a part of something great!</Typography>
            <Typography width="274px" sx={{...theme.typography.body,color:'#FFF'}}>
                Have anything in mind and feel sharing?
                You can reach us directly via email at:
            </Typography>
            <Typography mt='41px' fontSize="24px" fontFamily="Inter" textTransform="underline" color="#FFF" >info@careintouch.com</Typography>
        </Stack>
        <Stack bottom="0" right={{lg:"50px"}} position="absolute" direction="row" >
            { !isMobile && <img  height="371px" width="326px" src={Female} alt="Doctor Icon" />}
            <img  height="371px" width="304px" src={Male} alt="Doctor" />
        </Stack>
       

  

    </Box>
    )
}

export default withTheme(Banner);